import React, { useState } from 'react';
import { useAuth } from '../AuthContext'; // Import the useAuth hook
import axios from 'axios';
import {
  API_LOGIN
} from '../Config/ApiUrlConstant'; // Import your constants
import CryptoJS from 'crypto-js';
const SECRET_KEY = 'your-frontend-secret'; // Should match backend key

const LoginForm = () => {
  const { login } = useAuth(); // Access the login function from the context
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(''); // Store error message

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      // Encrypt username and password
      const encryptedUsername = CryptoJS.AES.encrypt(username, SECRET_KEY).toString();
      const encryptedPassword = CryptoJS.AES.encrypt(password, SECRET_KEY).toString();
      // console.log("encryptedUsername->",encryptedUsername,"encryptedPassword->",encryptedPassword)
      const response = await axios.post(API_LOGIN, {
        username: encryptedUsername,
        password: encryptedPassword,
      });
      // console.log("response->",response)
      if (response.data.token) {
        login(response.data.token);
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError('Something went wrong. Please try again later.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2 className="login-title">Login</h2>
        {error && <div className="error-message">{error}</div>} {/* Display error message */}
        <form onSubmit={handleSubmit}>
          <div>
            <label>Username</label>
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Password</label>
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="login-button">Login</button>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
